// JDG Tempur-Pedic Breeze Collection JS
(function() {

  var PRODUCTS = {
    probreeze: {
      title:    'TEMPUR-ProBreeze®',
      handle:   'tempur-5-cooler-probreeze®',
      priceFrom: 3899,
      hasFeel:  true,
      variants: {
        'Twin XL|Medium Hybrid':       { id: '53102862925935', price: 3899 },
        'Twin XL|Medium':              { id: '53102862958703', price: 3899 },
        'Queen|Medium':                { id: '53102863220847', price: 4399 },
        'Queen|Medium Hybrid':         { id: '53102863188079', price: 4399 },
        'King|Medium Hybrid':          { id: '53102863122543', price: 5099 },
        'King|Medium':                 { id: '53102863155311', price: 5099 },
        'Cal King|Medium Hybrid':      { id: '53102863253615', price: 5099 },
        'Cal King|Medium':             { id: '53102863286383', price: 5099 },
        'Split King|Medium Hybrid':    { id: '53102863057007', price: 7798 },
        'Split King|Medium':           { id: '53102863089775', price: 7798 },
        'Split CA King|Medium Hybrid': { id: '53102862991471', price: 7798 },
        'Split CA King|Medium':        { id: '53102863024239', price: 7798 }
      },
      feels: ['Medium','Medium Hybrid'],
      sizes: ['Twin XL','Queen','King','Cal King','Split King','Split CA King']
    },
    luxebreeze: {
      title:    'TEMPUR-LuxeBreeze®',
      handle:   '10-cooler-luxebreeze®',
      priceFrom: 5199,
      hasFeel:  false,
      variants: {
        'Twin XL':       { id: '53172686553199',  price: 5199  },
        'Queen':         { id: '53172686684271',  price: 5699  },
        'King':          { id: '53172686651503',  price: 6399  },
        'Cal King':      { id: '53172686717039',  price: 6399  },
        'Split King':    { id: '53172686618735',  price: 10398 },
        'Split CA King': { id: '53172686585967',  price: 10398 }
      },
      feels: [],
      sizes: ['Twin XL','Queen','King','Cal King','Split King','Split CA King']
    }
  };

  var currentModel = 'probreeze';
  var currentSize  = 'Queen';
  var currentFeel  = 'Medium';

  function fmt(p) { return '$' + p.toLocaleString('en-US'); }

  function getVariant() {
    var pr = PRODUCTS[currentModel];
    var key = pr.hasFeel ? currentSize + '|' + currentFeel : currentSize;
    return pr.variants[key] || null;
  }

  function updatePrice() {
    var v  = getVariant();
    var pr = PRODUCTS[currentModel];
    var pe = document.getElementById('jdg-breeze-price');
    var ne = document.getElementById('jdg-breeze-price-note');
    if (!pe) return;
    pe.textContent = v ? fmt(v.price) : 'From ' + fmt(pr.priceFrom);
    ne.textContent = v ? (pr.hasFeel ? currentSize + ' · ' + currentFeel : currentSize) : 'Select size above';
  }

function updateButtons() {
    var v        = getVariant();
    var pr       = PRODUCTS[currentModel];
    var viewBtn  = document.getElementById('jdg-breeze-view-btn');
    var cartForm = document.getElementById('jdg-breeze-cart-form');
    var vidInput = document.getElementById('jdg-breeze-vid');

    if (viewBtn) {
      viewBtn.href = v ? '/products/' + pr.handle + '?variant=' + v.id : '/products/' + pr.handle;
    }
    if (cartForm && vidInput) {
      if (v && v.id) {
        cartForm.style.display = 'block';
        vidInput.value = v.id;
      } else {
        cartForm.style.display = 'none';
      }
    }
  }
  function updateFeelSection() {
    var pr = PRODUCTS[currentModel];
    var fc = document.getElementById('jdg-breeze-feels');
    if (!fc) return;

    var feelSec = document.getElementById('jdg-breeze-feel-section');
    if (feelSec) {
      feelSec.style.display = pr.hasFeel ? 'block' : 'none';
    } else {
      fc.style.display = pr.hasFeel ? 'flex' : 'none';
      var prev = fc.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('jdg-rp-label')) {
        prev.style.display = pr.hasFeel ? 'block' : 'none';
      }
    }

    fc.innerHTML = '';
    if (pr.hasFeel) {
      pr.feels.forEach(function(f, i) {
        var b = document.createElement('button');
        b.className   = 'jdg-rp-opt' + (i === 0 ? ' selected' : '');
        b.textContent = f;
        b.onclick     = function() { selectFeel(f, b); };
        fc.appendChild(b);
      });
      currentFeel = pr.feels[0];
    }
  }

  function updateRightPanel() {
    var pr = PRODUCTS[currentModel];
    var te = document.getElementById('jdg-breeze-rp-title');
    if (te) te.textContent = pr.title + ' Collection';

    updateFeelSection();

    var sc = document.getElementById('jdg-breeze-sizes');
    if (sc) {
      var firstAvailable = null;
      sc.querySelectorAll('.jdg-size-btn').forEach(function(b) {
        var avail = pr.sizes.indexOf(b.dataset.size) !== -1;
        b.classList.toggle('disabled', !avail);
        b.classList.remove('selected');
        if (avail && !firstAvailable) firstAvailable = b.dataset.size;
      });
      var pick = pr.sizes.indexOf('Queen') !== -1 ? 'Queen' : firstAvailable;
      if (pick) {
        currentSize = pick;
        var pickBtn = sc.querySelector('.jdg-size-btn[data-size="' + pick + '"]');
        if (pickBtn) pickBtn.classList.add('selected');
      }
    }

    updatePrice();
    updateButtons();
  }

  function selectModel(m) {
    currentModel = m;
    document.querySelectorAll('.jdg-model-card').forEach(function(c) {
      c.classList.toggle('active', c.dataset.model === m);
    });
    document.querySelectorAll('.jdg-rp-opt[data-model]').forEach(function(o) {
      o.classList.toggle('selected', o.dataset.model === m);
    });
    updateRightPanel();
  }

  function selectSize(s, el) {
    if (el.classList.contains('disabled')) return;
    currentSize = s;
    document.querySelectorAll('.jdg-size-btn').forEach(function(b) { b.classList.remove('selected'); });
    el.classList.add('selected');
    updatePrice(); updateButtons();
  }

  function selectFeel(f, el) {
    currentFeel = f;
    document.querySelectorAll('#jdg-breeze-feels .jdg-rp-opt').forEach(function(b) { b.classList.remove('selected'); });
    el.classList.add('selected');
    updatePrice(); updateButtons();
  }

  window.jdgBreeze = { selectModel: selectModel, selectSize: selectSize, selectFeel: selectFeel };

  document.addEventListener('DOMContentLoaded', function() { updateRightPanel(); });

})();